import React from "react";
import { Spinner, Button } from "@blueprintjs/core";
import AddBankAccountForm from "./AddBankAccountForm";
import styles from "./BankAccount.module.scss";
import { useChangeProfileBankInfo } from "./hook";
import BankAccountCard from "./BankAccountCard";
import SettingsTab from "../SettingsTab";
import { Toolbar } from "../../../molecules/Toolbar";
import SettingsForm from "../SettingsForm";

function BankAccountSettings() {
  const bankAccountProps = useChangeProfileBankInfo();
  const {
    bankInfo,
    data,
    loading,
    addAccount,
    setAddAccount
  } = bankAccountProps;
  const { bank } = bankInfo;

  const isBankAdded = bank && bank.digits !== null && bank.name !== null;

  if (loading || !data) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }

  return (
    <SettingsTab>
      <Toolbar title="Settings" />
      <SettingsForm>
        {!isBankAdded && !addAccount && (
          <div className={styles.firstProductPrompt}>
            <span className={styles.cardTitle}>
              Please add your bank account to your profile{" "}
            </span>
            <span className={styles.cardMessage}>
              Adding your bank account allows you to cash out earnings from
              purchases through your videos.
            </span>
            <div className={styles.buttons}>
              <Button
                className="filled narrow"
                onClick={() => {
                  setAddAccount(true);
                }}
              >
                Add Bank Account
              </Button>
            </div>
          </div>
        )}
        {isBankAdded && !addAccount && (
          <BankAccountCard
            isBankAdded={isBankAdded}
            {...bankAccountProps}
            bank={bank}
          />
        )}
        {addAccount && <AddBankAccountForm {...bankAccountProps} />}
      </SettingsForm>
    </SettingsTab>
  );
}

export default BankAccountSettings;
